import { useEffect, useState } from 'react';
import { parseRuDate } from '@/lib/format';
import { maskDate, maskedChange } from '@/lib/mask';

const toRu = (iso: string | null) => (iso ? iso.split('-').reverse().join('.') : '');

/**
 * Дата, набранная руками в формате ДД.ММ.ГГГГ, точки ставит маска
 * (доработка M2-1 п. 2). Так дата вводится в модальных окнах, где
 * календарь-поповер обрезается (CLAUDE.md).
 * Наружу — ISO или null; `valid` говорит, разобралась ли строка.
 * Правила вроде «не в будущем» проверяет сервер — текст отказа от него.
 */
export function DateInput({
  label,
  value,
  onChange,
  hint,
  error,
}: {
  label: string;
  value: string | null;
  onChange: (iso: string | null, valid: boolean) => void;
  hint?: string;
  error?: string | null;
}) {
  const [text, setText] = useState(toRu(value));
  useEffect(() => {
    if (parseRuDate(text) !== value) setText(toRu(value));
    // текст правит только пользователь; внешнее значение — при смене снаружи
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const bad = text.trim() !== '' && !parseRuDate(text);
  const shownError = error ?? (bad ? 'Формат ДД.ММ.ГГГГ' : null);

  return (
    <label className={shownError ? 'field bad' : 'field'}>
      <span className="lbl">{label}</span>
      <input
        inputMode="numeric"
        placeholder="ДД.ММ.ГГГГ"
        value={text}
        onChange={(e) => {
          const next = maskedChange(text, e.target.value, e.target.selectionStart, maskDate);
          setText(next);
          const iso = parseRuDate(next);
          onChange(iso, next.trim() === '' || iso !== null);
        }}
      />
      {shownError ? <span className="err">{shownError}</span> : hint ? <span className="fh2">{hint}</span> : null}
    </label>
  );
}
